import React from "react";
import PropTypes from "prop-types";
import I18N from "../../I18N";
import { TestBox, CheckResult } from "../index";

const AppStatus = ({ appStatus, handleReTest }) => {
  const { isOnline = false , isLoading} = appStatus;
  return (
    <TestBox
      testName={I18N.t("APP_STATUS")}
      handleReTest={handleReTest}
      isLoading={isLoading}
    >
      <div style={{marginTop: '20px'}}>
        <p>{isOnline ? `${I18N.t("ONLINE")}` : `${I18N.t("OFFLINE")}`}</p>
        <CheckResult isSuccess={isOnline} />
      </div>
    </TestBox>
  );
};

AppStatus.propTypes = {
  appStatus: PropTypes.object.isRequired,
  handleReTest: PropTypes.func.isRequired
};

export default AppStatus;
